export default "__VITE_ASSET__cAX9EgzM__"